import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const cache = new Map();

export async function getContent(name) {
  if (cache.has(name)) return cache.get(name);
  const { data } = await axios.get(`${API}/content/${name}`);
  cache.set(name, data);
  return data;
}

export async function getPrayerTimes(lat, lon, method = 2) {
  const { data } = await axios.get(`${API}/prayer-times`, {
    params: { latitude: lat, longitude: lon, method }
  });
  return data?.data;
}

export async function getHijriToday() {
  const { data } = await axios.get(`${API}/hijri-today`);
  return data?.data;
}
